import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { LoginService } from '../login/login.service';
import { HelpersService } from '../helpers/helpers.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as CryptoJS from 'crypto-js';
import { DownloadService } from '../downloads/download.service';
import { ToastService } from '../toast/toast.service';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';


@Injectable({
  providedIn: 'root'
})
export class EngagementService {
  //variable declaration
  isAccount: boolean = true;
  manager_type = null;
  group_id: string = '';
  shop_id: string = '';
  engagemetState: any = {}
  private isFullscreenEngagementSubject = new BehaviorSubject<boolean>(false);
  isFullscreenEngagement$ = this.isFullscreenEngagementSubject.asObservable();
  dropdownOtions: any = []
  hierarchyLevels: any = []
  mappedHierarchy: any = {}
  brandDetails: any = {}
  selectedDrilldownFilter: any;
  drilldownTable: any;
  filters: any = [];
  trendDisplayName = "";
  isSingleTouchpointSetup: boolean = false;
  scaleRaterType: any = {};
  scalerTypeFieldId: number = 0;
  selectedRaterType: any = {};
  private drilldownFiltersSubject = new BehaviorSubject<any[]>([]);
  filters$ = this.drilldownFiltersSubject.asObservable();
  constructor(
    public _utilService: UtilsService,
    public loginService: LoginService,
    public helperservice: HelpersService,
    private downloadService: DownloadService,
    private _toastService: ToastService) {}
  setFullScreen(componentName: string, isFullScreen: boolean){
    this.engagemetState = {}
    this.engagemetState[componentName] = isFullScreen
  }
  getFullScreen(componentName: string){
    return this.engagemetState[componentName]
  }
  getFullscreenEngagement(): boolean {
    return this.isFullscreenEngagementSubject.value;
  }
  setFullscreenEngagement(value: boolean) {
    this.isFullscreenEngagementSubject.next(value);
  }
  setSelectedRaterType(raterType: any) {
    this.selectedRaterType = raterType;
  }
  getSelectedDrilldownFilter(){
    return this.selectedDrilldownFilter;
  }
  setSelectedDrilldownFilter(filter){
    this.selectedDrilldownFilter = filter
  }
  clearSelectedDrilldownFilter(){
    this.selectedDrilldownFilter = null
  }
  getInitializedTable(table?:any){
    let initializedTable = _.cloneDeep(table)
    initializedTable['tableRow'] = this.resetMetrics(initializedTable['tableRow']);
    if(initializedTable){
      this.drilldownTable = initializedTable;
    }
  }
  resetMetrics(data) {
    if(data.length){
      data.forEach(item => {
        item.number_of_request_generated_rated = 0;
        item.number_of_unique_requests_delivered = 0;
        item.responseRate = "0.0";
        item.notResponded = 0;
    
        if (Array.isArray(item.drillDown) && item.drillDown.length > 0) {
          this.resetMetrics(item.drillDown);
        }
      });
      return data;
    } else {
      return [];
    }
  }
  clearDrilldownHistory(){
    this.drilldownTable = [];
    this.clearSelectedDrilldownFilter();
    // Also clear and emit filters so subscribers (e.g., engagement-pro) don't retain stale state
    this.filters = [];
    this.drilldownFiltersSubject.next(this.filters);
  }
  generateApiParams(data, baseParams) {
  const result:any = [];
  const filtersArray:any = [];

  function traverse(node, hierarchyStack = []) {
    if (node.isExpanded && Array.isArray(node.drillDown) && node.drillDown.length > 0) {
      const newStack:any = [...hierarchyStack, {
        field_id: node.field_id,
        field_type: node.field_type,
        field_value: node.name,
        group_key: [node.name]
      }];

      const childFieldId = node.drillDown[0].field_id;

      // Push the API param object
      result.push({
        ...baseParams,
        hierarchy_stack: newStack,
        field_id: childFieldId,
        group_key_alias: node.field_id,
        field_type: "hierarchy"
      });
      if (node.field_id && node.name) {
        filtersArray.push({
          field_id: node.field_id,
          group_key: node.name
        });
      }
      node.drillDown.forEach(child => traverse(child, newStack));
    }
  }

  data.forEach(region => traverse(region));

  return {api_params: result, filters: filtersArray};
}

  getDisplayName(){
    let hierarchyStack = this.helperservice.getHierarchyStack()
    if (Helpers?.isAccount && Helpers?.accountDetails?.display_name){
      return Helpers?.accountDetails?.display_name;
    } else if (hierarchyStack && hierarchyStack.length && hierarchyStack[hierarchyStack.length - 1]?.group_key[0]){
      return hierarchyStack[hierarchyStack.length - 1]?.group_key[0];
    } else if (Helpers?.brandDetails?.name){
      return Helpers?.brandDetails?.name;
    } else {
      return "NA";
    }
  }

  prepareScalerRaterType(): void {
      let scalerOptions: any[] = [];
      const brandListDetail: any = _.get(Helpers, 'brandListDetail', null);
      if(brandListDetail) {
        brandListDetail.forEach(brandInfo => {
          const extenderRaterType: number | null = Number(brandInfo?.extender_rater_type) || null;
          const mainRaterType: number = !isNaN(Number(brandInfo?.main_rater_type)) ? Number(brandInfo?.main_rater_type) : 2;
          const scalerOptionName = extenderRaterType === 4 ? '1 to 5 Star scale' : this.getRaterTypeName(mainRaterType);
          if (!scalerOptions.some(option => option.name === scalerOptionName) && (brandInfo?.show_on_dashboard === true || brandInfo?.show_on_dashboard == null)) {
            scalerOptions.push({ name: scalerOptionName, field_id: extenderRaterType === 4 ? 3 : mainRaterType === 0 ? 2 : mainRaterType });
          }
        })
        scalerOptions.unshift({name: "All", field_id: -1})
        this.scaleRaterType = {
          selectedOption: scalerOptions[0].name,
          options: scalerOptions
        };
        if(!this.selectedRaterType?.field_id){
          this.setSelectedRaterType(scalerOptions[0]);
        }
        this.scalerTypeFieldId = this.scaleRaterType?.options[0]?.field_id;
      }
    }
    
    private getRaterTypeName(value: number): string {
      switch (value) {
        case 1: return '-5 to +5';
        case 2: return 'Others';
        case 3: return '0 to 10';
        case 4: return '1 to 5';
        case 6: return '1 to 10';
        case 7: return '1 to 6';
        case 8: return '-3 to +3';
        case 9: return '1 to 4';
        default: return 'Others';
      }
    }

  getFirstTrendTypeForDateRange(datePicker: any): { name: string, value: number } {
     const from = moment(datePicker.startDate, "YYYYMMDD").startOf('day');
  const to = moment(datePicker.endDate, "YYYYMMDD").endOf('day');

  const dtDiff = to.diff(from, 'days');

  // Handle custom date range
  if (datePicker.isCustomDateRangeSelected || datePicker.selectedTrend === undefined) {
    if (dtDiff === 0) {
      return datePicker.startDate === datePicker.endDate ? { name: "Hourly", value: 0 } : { name: "Daily", value: 1 };
    }
    if (dtDiff <= 6) {
      return { name: "Daily", value: 1 };
    }
    if (dtDiff <= 30) {
      return { name: "Daily", value: 1 };
    }
    if (dtDiff <= 91) {
      return { name: "Weekly", value: 2 };
    }
    if (dtDiff <= 364 || this.isYearSelected(from, to)) {
      return { name: "Weekly", value: 2 };
    }
    return { name: "Monthly", value: 3 };
  }

  // Handle predefined trend selection
  const trendType = datePicker.selectedTrend;
  if (trendType === 1) {
    return { name: "Hourly", value: 0 };
  }
  if (trendType === 2) {
    return { name: "Daily", value: 1 };
  }
  if (trendType === 3) {
    return { name: "Daily", value: 1 };
  }
  if (from.quarter() === to.quarter() && from.year() === to.year()) {
    return { name: "Weekly", value: 2 };
  }
  if (from.year() === to.year()) {
    return { name: "Weekly", value: 2 };
  }

  return { name: "Weekly", value: 2 };
}

  isYearSelected(from, to) {
    var startOfYear = moment(from).startOf('year').startOf('day');
    var endOfYear = moment(from).endOf('year').endOf('day');

    return from.isSame(startOfYear) && to.isSame(endOfYear);
  }
  formatNumber(value: number | string): string {
    if (typeof value === 'string' && value.endsWith('%')) {
      return value; // Return the percentage string as is
    }
    if (isNaN(Number(value))) return '0';
    const number = typeof value === 'string' ? Number(value) : value;

    const numberString = number.toString();
    const [integerPart, decimalPart] = numberString.split('.');
    let lastThreeDigits = integerPart.slice(-3);
    let otherDigits = integerPart.slice(0, -3);
    if (otherDigits) {
      lastThreeDigits = ',' + lastThreeDigits;
    }
    const formattedIntegerPart = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThreeDigits;
    return decimalPart ? formattedIntegerPart + '.' + decimalPart : formattedIntegerPart;
  }
  
  formatNumberValuesInArray(data: any[], keysToFormat: string[]): any[] {
    if (!data || !Array.isArray(data)) return data;
    
    return data.map(obj => {
      const formatted = { ...obj };
      keysToFormat.forEach(key => {
        if (key in formatted && formatted[key] !== null && formatted[key] !== undefined) {
          formatted[key] = this.formatNumber(formatted[key]);
        }
      });
      
      // Recursively format drillDown arrays if they exist
      if (formatted.drillDown && Array.isArray(formatted.drillDown)) {
        formatted.drillDown = this.formatNumberValuesInArray(formatted.drillDown, keysToFormat);
      }
      
      return formatted;
    });
  }

  setDrilldownFilters(filters) {
    this.filters = [];
    if (filters && filters.filters && filters.filters.length) {
      _.each(filters.filters, (filter) => {
        if (filter && filter.field_id == filters.groupKeyAlias) {
          this.trendDisplayName = filter.field_value
        } else {
          this.trendDisplayName = this.getDisplayName()
        }
        if(filter.field_id && filter.group_key){
          let tmpObj = {
            "field_id": filter.field_id,
            "group_key": filter.group_key
          }
          this.filters.push(tmpObj);
        }
      })
    } else {
      this.filters = [];
      this.trendDisplayName = this.getDisplayName()
    }
    if (filters?.projectId) {
      this.filters.brand_id = filters?.projectId
    }
    if (filters?.brand_id_list?.length > 0) {
      this.filters.brand_id_list = filters?.brand_id_list
    }
    this.drilldownFiltersSubject.next(this.filters);

    return this.filters;
  }

  getDrilldownFilters() {
    return this.filters;
  }

  //connection of API
  getEngagementSummary(reqBody) {
    try {
      if (!reqBody || !reqBody.from || !reqBody.to) {
        return throwError(() => new Error('Invalid request: required params not provided.'));
      }
      const url = this._utilService.apiUrlGeneration(environment.analyticsV1, environment.analyticsV1.EngagementSummaryByAccount);
      return this._utilService.postAPICall(url, reqBody, this._utilService.setHeaders());
    } catch (error) {
      console.error('An unexpected error occurred while getting summary data:', error);
      return throwError('An unexpected error occurred while getting summary data.');
    }
  }

  //get initial query parameters
  getQueryParameters() {
    var QueryParams: any = {};
    var allow_current_date = _.get(Helpers, 'brandDetails.analytics_settings.request_analytics.allow_current_date', false);
    QueryParams.account_id = _.get(Helpers, 'accountDetails._id') //JSON.parse(this.decrypt(localStorage.getItem('ACCOUNT_ID') || ''));
    QueryParams.from = _.get(Helpers, 'datePicker.startDate');
    QueryParams.to = _.get(Helpers, 'datePicker.endDate');
    QueryParams.is_custom_date_range_selected = _.get(Helpers, 'datePicker.isCustomDateRangeSelected', false);
    this.manager_type = _.get(Helpers, 'accessObject.manager_type');
    if(allow_current_date){
      QueryParams.allow_current_date = true;
    }
    if (!this.manager_type) {
      this.loginService.getManagerDetails().subscribe((response) => {
        this.manager_type = response.data.loggedInManager ? response.data.loggedInManager.manager_type : '';

        //not required as of now
        // this.group_id = response.data.loggedInManager ? response.data.loggedInManager.group_id : ''
        // this.shop_id = response.data.loggedInManager ? response.data.loggedInManager.shop_id : ''
      })
    }

    if (Helpers && Helpers["isAccount"] && Helpers["isAccount"] == true) {this.isAccount=true} else {this.isAccount=false}

    if (!this.isAccount) {

      QueryParams["brand_id"] = (Helpers.brandDetails && Helpers.brandDetails._id) ? Helpers.brandDetails._id : null;
      QueryParams["rater_type"] = (Helpers.brandDetails && Helpers.brandDetails.main_rater_type) ? Helpers.brandDetails.main_rater_type : -1;
      QueryParams["timezone_offset"] = (Helpers.brandDetails && Helpers.brandDetails.default_time_zone) ? Helpers.brandDetails.default_time_zone.offset : 0;
      this.helperservice.appState.subscribe((response:any) => {
        if(response  && !response.pending){
          QueryParams["hierarchy_stack"] = response.hierarchyStack ? Helpers.hierarchyStack : [];
        }
      });

      //not required as of now
      // if (this.manager_type == 2) {
      //   QueryParams.brand_id = Helpers.brandDetails._id;
      // } else if (this.manager_type == 7) {
      //   QueryParams.group_id = this.group_id;
      // } else if (this.manager_type == 1) {
      //   QueryParams.shop_id = this.shop_id;
      // }
      // QueryParams['group_id'] = this.group_id;
      // QueryParams['shop_id'] = this.shop_id;

      // if(!Helpers.touchpointId && Helpers.shopIdList && Helpers.shopIdList.length){
      //                 params.shop_id_list = Helpers.shopIdList;
      //                 delete params.shop_id;
      //             }

    } else {
      QueryParams['timezone_offset'] = (Helpers.accountDetails && Helpers.accountDetails.default_time_zone) ? Helpers.accountDetails.default_time_zone.offset : 0;
      QueryParams["rater_type"] = -1;
    }
    return QueryParams;
  }

  //method to decrypt encrypted data 
  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(
      txtToDecrypt,
      environment.secureSessionStorage.key
    ).toString(CryptoJS.enc.Utf8);
  }

  // Returns the value of a nested property in an object.
  getProp(obj: any, str: string): any {
    str = str.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    str = str.replace(/^\./, ''); // strip a leading dot
    const a = str.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (obj && typeof obj === 'object') {
        if (k in obj) {
          obj = obj[k];
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    }
    return obj;
  }

  /**
   * this function used to get response score 
   * @param data 
   * @param rater_type 
   * @returns 
   */
  getResponseScore(data, rater_type) {
    let score = 0;
    if (data && data.number_of_request_generated_rated) {

      if (rater_type == 3 || rater_type == 10) {
        let sum = (data.promoters || 0) + (data.passives || 0) + (data.detractors || 0);
        score = (sum > 0) ? parseFloat(((((data.promoters || 0) / sum) * 100) - (((data.detractors || 0) / sum) * 100)).toFixed(1)) : 0;
        score = parseFloat(score.toString());
      } else {
        score = parseFloat(this.getAverageRating(data).toFixed(1));
      }
    }
    return score;
  }

  /**
   * this function will Calculates average rating from data, returning 0 if an error occurs.
   * @param data 
   * @returns 
   */
  getAverageRating(data) {
    let averageRating = 0;
    try {
      if (data) {
        if (data.sum_primary_rating && data.number_of_users_rated_primary_rating) {
          averageRating = (data.sum_primary_rating) / (data.number_of_users_rated_primary_rating);
        } else {
          averageRating = 0;
        }
      }
    } catch (e) {
      averageRating = 0;
    }
    return averageRating;
  }

  /**
   * this fuction adds the number of requests generated and rated, defaulting to 0 if they don't exist.
   * @param data 
   * @returns 
   */
  getRequestRecieved(data) {
    return (data.number_of_request_generated || 0) + (data.number_of_request_generated_rated || 0)
  }

  /**
   * this function used to get response rate percentage
   * @param summary summary object
   * @param is_icon_enabled boolean
   * @returns percetage
   */
  getResponeRate(summary, is_icon_enabled = false) {
    let response_rate = 0
    if (!_.isEmpty(summary)) {
      summary.number_of_unique_delivered = summary.number_of_unique_requests_delivered;
      if (summary.number_of_requests_received == 0 && summary.number_of_unique_requests_delivered == 0 && summary.number_of_request_generated_rated == 0) {
        response_rate = 0;
      } else if ((summary.number_of_requests_received == summary.number_of_request_generated_rated) && summary.number_of_request_generated_rated >= 0) {
        response_rate = 100;
      } else {
        response_rate = (this.getResponsePercentage(summary)).toFixed(1);
      }
    }
    return (response_rate && is_icon_enabled) ? response_rate + "%" : response_rate;
  }

  /*
    @Description - 
        - Calculates responded percentage
    Changes - 
        - Checking for NAN e.g. 0/0
        - Formula changes for Response%
        - Formula added is #Responses/(#Delivered or #Sent)
        - Removed Unique Invitaion and Reminder fields
 */
  getResponsePercentage(data) {
    data = JSON.parse(JSON.stringify(data));
    data.number_of_unique_delivered = data.number_of_unique_delivered || data.number_of_unique_sent || 0;
    data.number_of_unique_delivered = data.number_of_unique_requests_delivered ? data.number_of_unique_requests_delivered : data.number_of_unique_delivered;
    data.responded_percentage = 0;
    // let totalRatings = (data.number_of_request_generated_rated)?data.number_of_request_generated_rated:
    let totalResponded = 0;

    if (data.number_of_request_generated_rated) {
      totalResponded = data.number_of_request_generated_rated;
    } else if (data.number_of_users_rated) {
      totalResponded = data.number_of_users_rated;
    }
    let delivered = (data.number_of_unique_delivered == 'NA' || !data.number_of_unique_delivered) ? 0 : data.number_of_unique_delivered;
    if (data.utm_medium_link) {
      delivered = delivered + data.utm_medium_link;
    }
    // this is currently excluded from stats32 delivered in lw2 dashboard
    // if (data.utm_medium_kiosk) {
    //   delivered = delivered + data.utm_medium_kiosk;
    // }
    // if (data.utm_medium_qrcode) {
    //   delivered = delivered + data.utm_medium_qrcode;
    // }

    if (delivered >= totalResponded) {
      data.responded_percentage = (totalResponded / delivered) * 100;
    }
    if (Helpers.brandDetails && Helpers.brandDetails.project_info && Helpers.brandDetails.project_info.response_medium && Helpers.brandDetails.project_info.response_medium.toString() == "4") {
      var totalRequests = totalResponded
      if (!isNaN(data.number_of_request_generated)) {
          totalRequests += parseInt(data.number_of_request_generated);
      }
      if (totalResponded != 0 && totalRequests != 0) {
          data.responded_percentage = (totalResponded / totalRequests) * 100;
      }
  }
    let responded_percentage = isNaN(data.responded_percentage) ? 0 : data.responded_percentage;
    return responded_percentage;
  };

  //parameters for page view component
  getPageViewParams(paramsData: any) {
    var params = this.getQueryParameters();

    params.from = _.get(Helpers, 'datePicker.startDate');
    params.to = _.get(Helpers, 'datePicker.endDate');
    params['query_type'] = paramsData.query_type ? paramsData.query_type : 1;
    params['view_type'] = 'summary';
    params['is_trend_data'] = paramsData.is_trend_data ? paramsData.is_trend_data : true;
    if (paramsData.is_deviation_enabled !== undefined) {
      params['is_deviation_enabled'] = paramsData.is_deviation_enabled;
    }

    this.applyComparisonApiDateRangeIfNeeded(params);
    return params;
  }

  private applyComparisonApiDateRangeIfNeeded(params: any): void {
    applyComparisonApiDateRange(params, _.get(Helpers, 'datePicker', null));
  }

  //parameters for Details page component
  getDetailsParams(paramsData: any) {
    var params = this.getQueryParameters();
    params.from = _.get(Helpers, 'datePicker.startDate');
    params.to = _.get(Helpers, 'datePicker.endDate');
    params['query_type'] = paramsData.query_type ? paramsData.query_type : 1;
    params['view_type'] = paramsData && paramsData.view_type ? paramsData.view_type : 'hierarchy';
    params['rater_type'] = this.selectedRaterType?.field_id ? this.selectedRaterType.field_id : -1;
    params['is_trend_data'] = false;
    if (params['view_type'] == 'hierarchy') {
      params['field_type'] = 'group';
      params['field_id'] = paramsData.field_id ? paramsData.field_id : 'project';
    } else {
      params['trend_type'] = paramsData.trend_type
    }
    if (paramsData.is_deviation_enabled !== undefined) {
      params['is_deviation_enabled'] = paramsData.is_deviation_enabled;
    }
    this.applyComparisonApiDateRangeIfNeeded(params);
    return params;
  }


  //parameters for engagement lite/pro page component
  getSummaryParams(paramsData: any) {
    var params = this.getQueryParameters();

    if (params.hierarchy_stack && paramsData.filters && paramsData.filters.length) {
      params.hierarchy_stack = params.hierarchy_stack.concat(paramsData.filters)
    }

    params.from = _.get(Helpers, 'datePicker.startDate');
    params.to = _.get(Helpers, 'datePicker.endDate');
    params['query_type'] = paramsData.query_type ? paramsData.query_type : 2;
    params['view_type'] = paramsData.view_type ? paramsData.view_type : "summary";
    params['is_trend_data'] = false;
    params['rater_type'] = this.selectedRaterType?.field_id ? this.selectedRaterType.field_id : -1;
    params['trend_type'] = paramsData.trend_type
    params['message'] = paramsData.message
    if (paramsData.is_deviation_enabled !== undefined) {
      params['is_deviation_enabled'] = paramsData.is_deviation_enabled;
    }
    this.applyComparisonApiDateRangeIfNeeded(params);
    return params;
  }
  // to restrict today and yesterday in engagement tabs
  is_valid_date_range(to, from): boolean {
    from = moment(from, "YYYYMMDD").startOf('date');
    to = moment(to, "YYYYMMDD").startOf('date');
    var twoDaysAgo = moment().subtract(2, 'days').startOf('day');
    var allow_current_date = _.get(Helpers, 'brandDetails.analytics_settings.request_analytics.allow_current_date', false);
    if (from.isAfter(twoDaysAgo) && !allow_current_date) {
      return false;
    }
    return true;
  }
  configureEngagementService(brandDetails: any) {
    this.brandDetails = brandDetails
    this.isSingleTouchpointSetup = _.get(brandDetails, 'is_single_touchpoint_setup', false)
    // this.setQuestionAndQuestionGroup(brandDetails)
    this.setDropDownOptions(brandDetails)
    // this.setClosedStatus(brandDetails)
    // return this.questionMapping;
  }
  private setDropDownOptions(brandDetail: any) {
    let options: any[] = []
    if (brandDetail.hierarchy_list && !_.isEmpty(brandDetail.hierarchy_list) && brandDetail.hierarchy_list_alias && !_.isEmpty(brandDetail.hierarchy_list_alias)) {
      var hierarchyList = _.get(brandDetail, 'hierarchy_list');
      var hierarchyListAlias = _.get(brandDetail, 'hierarchy_list_alias');
      var keys = Object.keys(hierarchyList);
      keys = _.filter(keys, (key: string) => {
        return key != 'default';
      });
      var labels = hierarchyList[keys[0]];
      var fields = hierarchyListAlias[keys[0]].values
      this.hierarchyLevels = fields
      for (let key in fields) {
        const alias = fields[key]
        this.dropdownOtions.push({
          'field_id': alias,
          'name': labels[key],
          'type': 'hierarchy',
          'category': 'Hierarchy'
        })
        this.mappedHierarchy[alias] = {
          'field_id': alias,
          'name': labels[key],
          'type': 'hierarchy',
          'category': 'Hierarchy'
        }
      }
    }
    if (brandDetail.field_definitions && !_.isEmpty(brandDetail.field_definitions)) {
      let fieldDefinitions = _.get(brandDetail, 'field_definitions')
      _.each(fieldDefinitions, (field: any) => {
        if (field.compare_filter) {
          field.type = 'tag'
          field.category = 'Cohorts'
          this.dropdownOtions.push(field);
        } else if (field.field_type && field.field_type == 'response') {
          field.category = 'Cohorts'
          if (field.question) {
            field.name = field.question;
          } else {
            field.name = field.text;
          }
          // if (field.type && field.type == "multi-select") {
          //   field = this.getPrpsAndPossibleValuesForMultiSelect(field);
          // }
          this.dropdownOtions.push(field);
        }
      })
    }

    return options;
  }
  getGroupAlias(fieldId: string) {
    const index = this.hierarchyLevels.indexOf(fieldId)
    let groupAliasKey = fieldId
    if (groupAliasKey == 'touchpoint') {
      groupAliasKey = this.hierarchyLevels[this.hierarchyLevels.length - 1]
    } else if (index <= 0) {
      groupAliasKey = 'brands';
    } else {
      groupAliasKey = this.hierarchyLevels[index - 1]
    }
    return groupAliasKey;
  }

  getGroupAliasKey(fieldId: string, hierarchyListAlias: any) {
    let hierarchyLevels: any = []
    let groupAliasKey = fieldId;
    if (!_.isEmpty(hierarchyListAlias)) {
      var keys = Object.keys(hierarchyListAlias);
      hierarchyLevels = hierarchyListAlias[keys[0]].values;
    }
    if (fieldId) {
      const index = hierarchyLevels.indexOf(fieldId);
      if (index < hierarchyLevels.length - 1) {
        groupAliasKey = hierarchyLevels[index + 1]
      }
    } else {
      groupAliasKey = 'brands'
    }
    return groupAliasKey
  }
  prepareViewTypeDropdown(brandDetail: any, hierarchyStack: any) {
    let options: any = [];
    let hierarchyList: any = [];
    let hierarchyMapping: any = [];
    let selectedHierarchyKey: string = '';
    let hierarchyListAliasValue: any = [];
    let currentHierarchyLevel: string = '';
    let currentHierarchyLevelName: string = '';
    let group_key_alias: string = '';
    let obj: any = {}
    const isAccountUser: any = _.get(Helpers, 'isAccount', null);
    const isAccountManager: any = _.get(Helpers, 'isAccountManager', null);

    if(isAccountUser) {
      options.push({name: 'Projects', field_id: "project", field_type: "project"});
    } else if(isAccountUser === false) {
      let hierarchyListFromBrand = brandDetail?.hierarchy_list;
      for (let key in hierarchyListFromBrand) {
        selectedHierarchyKey = key;
        hierarchyList = hierarchyListFromBrand[key];
      }
      let hierarchyListAliasValueFromBrand = brandDetail?.hierarchy_list_alias;
      if (hierarchyListAliasValueFromBrand && hierarchyListAliasValueFromBrand[selectedHierarchyKey]) {
        hierarchyListAliasValue = hierarchyListAliasValueFromBrand[selectedHierarchyKey]?.values;
      }
      if (hierarchyList && hierarchyList.length > 0) {
        hierarchyListAliasValue.forEach((item, index) => {
          hierarchyMapping[item] = hierarchyList[index];
        })
        if (hierarchyStack && hierarchyStack.length > 0 && !isAccountManager) {
          currentHierarchyLevel = hierarchyStack[hierarchyStack.length - 1]?.field_id;
          currentHierarchyLevelName = hierarchyStack?.[hierarchyStack.length - 1]?.group_key[0];
          if (currentHierarchyLevel && currentHierarchyLevel != '') {
            let startAdding: boolean = false;
            for (let key in hierarchyMapping) {
              if (startAdding) {
                if (hierarchyMapping[key]) {
                  options.push({ name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy' });
                }
              }
              if (key === hierarchyListAliasValue[hierarchyListAliasValue.indexOf(currentHierarchyLevel) + 1]) {
                startAdding = true;
                if (hierarchyMapping[key]) {
                  options.push({ name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy' });
                }
              }
            }
          } else {
            currentHierarchyLevel = hierarchyListAliasValue[0];
            currentHierarchyLevelName = hierarchyList[0];
            for (let key in hierarchyMapping) {
              if (hierarchyMapping[key]) {
                options.push({ name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy' });
              }
            }
          }
        } else {
          currentHierarchyLevel = hierarchyListAliasValue[0];
          currentHierarchyLevelName = hierarchyList[0];
          for (let key in hierarchyMapping) {
            if (hierarchyMapping[key] && key !== Object.keys(hierarchyMapping)[0]) {
              options.push({ name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy' });
            }
          }
        }
        group_key_alias = hierarchyListAliasValue[hierarchyListAliasValue.indexOf(currentHierarchyLevel) + 1];
      }
    }
    obj = {
      hierarchyMapping: hierarchyMapping,
      options: options,
      hierarchyList: hierarchyList,
      hierarchyListAliasValue: hierarchyListAliasValue,
      group_key_alias: group_key_alias,
      currentHierarchyLevel: currentHierarchyLevel,
      currentHierarchyLevelName: currentHierarchyLevelName
    }
    return obj;
  }

  getNextHierarchy(fieldId: string) {
    let filter: any = {}
    const index = this.hierarchyLevels.indexOf(fieldId);

    if (this.hierarchyLevels[index + 1]) {
      const alias = this.hierarchyLevels[index + 1]
      filter = this.mappedHierarchy[alias];
    } else if (!this.isSingleTouchpointSetup && fieldId != 'touchpoint') {
      filter = {
        'field_id': 'touchpoint',
        'name': 'Touchpoints',
        'label': 'Touchpoints',
        'type': 'hierarchy'
      }
    }
    return filter;
  }

  isEndOfHierarchy(fieldId?: string) {
    if (fieldId) {
      const index = this.hierarchyLevels.indexOf(fieldId);
      // const value = this.brandDetails.is_single_touchpoint_setup ? 2 : 1;
      const value = 2;
      return (index >= (this.hierarchyLevels.length - value))
    }
    return true;

  }
  createDownloadJob(downloadQuery: any) {
    this.downloadService.createDashboardReportingJob(downloadQuery).subscribe((reponse: any) => {
      if (reponse && reponse.litmus_job) {
        this.downloadService.updateList(reponse.litmus_job)
        this.downloadService.showDownloadSideBar(true);
      } else if (reponse && reponse.code == 4021) {
        this._toastService.showPopup("WARN", "Please Wait", "Report generation is in process.", 3500);
      } else {
        this._toastService.showPopup("ERROR", "Error", "Error while generating request.", 3500);
      }
    })
  }
}
